import { styled } from '@arpeggi/ui'

const Root = styled('div', {
  display: 'flex',
  gap: '4px',
  borderBottomStyle: 'solid',
  borderBottomColor: '$blackA050',
  borderBottomWidth: '1px',
  paddingRight: '64px',
  '@tablet': {
    paddingRight: '100px'
  }
})

const Column = styled('div', {
  display: 'flex',
  alignItems: 'center',
  padding: '12px 16px',
  color: '$blackA500',
  fontWeight: 500,
  text: '12',
  variants: {
    clickable: {
      true: {
        cursor: 'pointer',
        '&:hover': { color: '$black' }
      }
    },
    active: {
      true: {
        color: '$black'
      }
    },
    layout: {
      main: {
        display: 'flex',
        alignItems: 'center',
        flexBasis: '270px',
        flexShrink: 0,
        flexGrow: 0,
        maxWidth: '270px'
      },
      fluid1: {
        flex: 1
      },
      fluid2: {
        flex: 2
      }
    }
  }
})

const Icon = styled('svg', {
  width: '12px',
  height: '12px',
  color: 'inherit'
})

export const Headers = { Root, Column, Icon }
